import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {v4 as uuidv4} from 'uuid';
import {submitDocumentFormAction} from "../../../Store/SubmitDocumentForm";
import utilsFunction from "../../../../utils/utilsFunction";


function AddNewRow(props) {
  const selectedRowId = props.cell.getData().uniqId;

  const sendData = useSelector(s => s.submitDocumentFormReducer)
  const dispatch = useDispatch();

  const lastUniqId = (tableArray) => {

    let lastUniqId
    tableArray?.forEach((v, index) => {

      if (tableArray.length === index+1) {
        lastUniqId = v.uniqId
      }
    })

    return lastUniqId
  }


  const findedLastUniqId = lastUniqId(sendData.tableData)
  if(+selectedRowId===+28){
    debugger
  }
  const isItLastId = (findedLastUniqId === selectedRowId);


  const addNewRowToTable = () => {

    const newTableData = [...sendData.tableData]
    const uniqId = utilsFunction.randomNumberGenerator()
    newTableData.push(
      {
        uniqId,
        indexRow: "",
        accountCode: "",
        value: "",
        accountTitle: "",
        description: "",
        floatingAccount: "",
        floatingAccountCode: "",
        floatingAccountTitle: "",
        bed: "",
        bes: "",
        level1Code: "",
        level1Name: "",
        level2Code: "",
        level2Name: "",
        level3Code: "",
        level3Name: "",
        level4Code: "",
        level4Name: "",
        level4FloatingCode: "",

      })
    dispatch(submitDocumentFormAction.fillInput({tableData: newTableData}))
  }
  return (
    <div>
      {
        isItLastId ? <div
          onClick={addNewRowToTable}
        >
          +
        </div> : <></>
      }</div>
  );
}

export default AddNewRow;